<button
    [ngClass]="['button', data().type === 'primary'? 'button--primary':'button--secondary']"
    [disabled]="disabled()"
>
    @if(data().icon){
        <img [src]="data().icon" alt="" width="22">
    }
    <app-wheel-dynamic-text [data]="data()"/>
</button>